<div class="grid-stack">
  <ng-content></ng-content>
</div>
